'use client';

import { postHogApiKey, postHogHost } from '@/config';
import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { useEffect } from 'react';
import SuspendedPostHogPageView from './posthog-page-view';

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    if (!postHogApiKey) {
      return;
    }

    posthog.init(postHogApiKey, {
      api_host: postHogHost,
      capture_pageview: false, // Disable automatic pageview capture, as we capture manually
      capture_pageleave: true,
    });
  }, []);

  return (
    <PHProvider client={posthog}>
      <SuspendedPostHogPageView />
      {children}
    </PHProvider>
  );
}
